import { MetaData } from '../models/meta.model'

const Meta = ({ meta }: { meta: MetaData }) => {
  if (!meta) return (<></>)

  return (<>
    {meta?.metaTitle && <title>{meta.metaTitle}</title>}
    {meta?.description && <meta key='description' name='description' content={meta.description} />}
    {meta?.metaTitle && <meta key='og:title' property='og:title' content={meta.metaTitle} />}
    {meta?.description && <meta key='og:description' property='og:description' content={meta.description} />}
    {meta?.ogImage?.fields?.file?.url &&
    <meta key='og:image' property='og:image' content={meta?.ogImage?.fields?.file?.url} />}
    <meta key='og:type' property='og:type' content='website' />
    {meta?.ogSiteName && <meta key='og:site_name' property='og:site_name' content={meta.ogSiteName} />}
    {meta?.ogLocale && <meta key='og:locale' property='og:locale' content={meta.ogLocale} />}
    {meta?.ogURL && <meta key='og:url' property='og:url' content={meta.ogURL} />}
    {meta?.keywords && <meta name='keywords' content={meta.keywords} />}
  </>)
}

export default Meta
